<template>
  <v-container class="pa-4 pt-1" fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <!-- <v-card class="ma-5" elevation="0"> -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Public Holiday</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            single-line
            hide-details
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mb-6">
          <v-btn
            to="/leave-holiday-import"
            rounded
            outlined
            color="blue"
            class="mb-2 ml-2 mr-2"
          >
            <span>Import</span>
            <v-icon small center>mdi-download</v-icon>
          </v-btn>
          <v-btn
            @click="openadd"
            color="#0A7EA5"
            rounded
            dark
            class="mb-2"
            :disabled="!authorize_add"
          >
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <v-data-table
          @page-count="pageCount = $event"
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item)"
              v-if="authorize_edit"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              class="ml-3"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }"
              @click="deleteItem(item)"
              v-if="authorize_del"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
        <v-progress-linear
          indeterminate
          color="teal"
          v-if="load_bg"
        ></v-progress-linear>
      </v-card>

      <v-dialog v-model="dialogAddData" max-width="500px">
        <v-card>
          <br />
          <v-card-title class="text-h6">New Holiday</v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="space-around" class="heightsize70formadvance">
                <v-col cols="12" sm="12" md="12">
                  <h3><span class="vali">*</span>Holiday Name</h3>
                  <v-text-field v-model="h_name" outlined dense></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="space-around" class="heightsize70formadvance">
                <v-col cols="12" sm="12" md="12">
                  <h3><span class="vali">*</span>Date</h3>
                  <v-menu
                    ref="menu_h"
                    v-model="menu_h"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFromFormatted"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_h" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_h = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_h.save(date_h)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              width="100"
              class="mr-3 buttonblue"
              @click="saveaddItem()"
            >
              Save
            </v-btn>
            <v-btn depressed outlined width="100" @click="closeaddItem()">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          <br />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card style="padding-top: 30px; padding-bottom: 30px;">
          <v-card-title style="padding-bottom: 20px;">
            <v-row justify="center">
              <span class="red--text text-h5 ju">Are you sure?</span>
            </v-row>
          </v-card-title>
          <br />
          <v-card-subtitle>
            <v-row justify="center">
              <span class="black--text"
                >Are you sure you want to delete this item</span
              >
            </v-row>
          </v-card-subtitle>
          <v-card-actions style="padding-top: 20px">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              width="100"
              class="mr-3 buttonblue"
              color="red"
              @click="deleteItemConfirm"
            >
              Save
            </v-btn>
            <v-btn depressed outlined width="100" @click="closeDelete">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <!-- <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card> -->
      </v-dialog>
    </v-card>
    <!-- </v-card> -->
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";
import unity from "@/unity/unity";

export default {
  name: "MasterTradeMark",
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      oper_id: 0,
      menu_h: false,
      h_name: "",
      date_old: "",
      date_h: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      load_bg: false,
      contact_type: [
        { contact_typenumber: 1, contact_typename: "Owner" },
        { contact_typenumber: 2, contact_typename: "Agent" },
        { contact_typenumber: 3, contact_typename: "Associate" },
      ],
      dialogAdd: false,
      dialogAddData: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,
      search: "",
      mDataArray: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      itemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
        status: "A",
      },
      edititemdata: {
        contact_type: 0,
        mapping_cust_id: 0,
        contact_name: "",
        contact_person: "",
        position: "",
        email: "",
        address: "",
        city: "",
        country: "",
        telephone: "",
        fax: "",
      },
      contactid_del: 0,
      oparation: "",
      headers: [
        {
          text: "ID",
          value: "id",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "Name",
          value: "h_name",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "Date",
          value: "date_show",
          class: "bg-colorth",
          divider: true,
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth",
          divider: true,
          width: "120px",
        },
      ],
      customer_name_list: [],
    };
  },
  async mounted() {
    this.$showLoader();
    await api.checkVersion();

    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    console.log("res_auth:" + JSON.stringify(res_auth.data));
    console.log("authorize_view:" + this.authorize_view);
    console.log("authorize_add:" + this.authorize_add);
    console.log("authorize_edit:" + this.authorize_edit);
    console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.back();
    }

    // ----------------- Check Authorize ---------------------------
    await this.loadData();
    this.$hideLoader();
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.date_h);
    },
  },

  methods: {
    async loadData() {
      const res_data = await api.getLeaveHolidayAll(
        localStorage.getItem(server.COMPANYID)
      );
      console.log("res_data.data");
      console.log(res_data.data);
      this.mDataArray = res_data.data;
      this.mDataArray.forEach((item) => {
        item.date_show = unity.formatDate(item.date);
      });
    },
    async openadd() {
      this.h_name = "";
      this.date_h = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.dialogAddData = true;
      this.oparation = "create";
    },
    async closeaddItem() {
      this.dialogAddData = false;
      this.h_name = "";
      this.date_h = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
    },

    openeditItem(item) {
      this.oparation = "update";
      this.oper_id = item.id;
      this.date_old = item.date;
      this.h_name = item.h_name;
      this.date_h = item.date;

      this.dialogAddData = true;
    },
    deleteItem(item) {
      console.log(item);
      this.dialogDelete = true;
      this.oper_id = item.id;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      // eslint-disable-next-line prettier/prettier, no-undef

      const delete_holiday = await api.deleteHoliday(this.oper_id);

      if (delete_holiday.status == 200 || delete_holiday.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialog(
          true,
          "Successfully  Deleted",
          "The public holiday has been successfully deleted.",
          "text-h5 green--text text-center"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }

      this.dialogDelete = false;
      await this.loadData();
      this.$hideLoader();
    },
    async saveaddItem() {
      this.dialogAddData = false;

      if (this.h_name == " " || this.h_name == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Holiday Name",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.oparation == "create") {
        const check_date = await api.getLeaveHolidayByDate(
          this.date_h,
          Number(localStorage.getItem(server.COMPANYID))
        );

        // console.log("create check_date.data:", JSON.stringify(check_date));
        // console.log("check_date.data")
        // console.log(check_date.data)

        if (check_date.data != null) {
          if (check_date.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please check the date and try again.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        var data_add = {};

        data_add.h_name = this.h_name;
        data_add.date = this.date_h;
        data_add.company_id = Number(localStorage.getItem(server.COMPANYID));

        this.$showLoader();
        console.log("start createHoliday");
        const create_holiday = await api.createHoliday(data_add);
        console.log("create check_date.data:", JSON.stringify(create_holiday));
        if (create_holiday.status == 200 || create_holiday.status == 201) {
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialog(
            true,
            "Sucessfully Added",
            "New public holiday has been added",
            "text-h5 green--text text-center"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        // console.log(this.date_old)
        // console.log(this.date_h)

        if (this.date_old != this.date_h) {
          const check_date = await api.getLeaveHolidayByDate(
            this.date_h,
            Number(localStorage.getItem(server.COMPANYID))
          );

          // console.log("check_date.data")
          // console.log(check_date.data)

          if (check_date.data != null) {
            if (check_date.data.length > 0) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Failed",
                "Please check the date and try again.",
                "text-h5 red--text text-center"
              );
              return;
            }
          }
        }

        var data_edit = {};

        data_edit.h_name = this.h_name;
        data_edit.date = this.date_h;

        console.log(this.oper_id);
        console.log(data_edit);

        this.$showLoader();

        const edit_holiday = await api.editHoliday(this.oper_id, data_edit);

        if (edit_holiday.status == 200 || edit_holiday.status == 201) {
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialog(
            true,
            "Sucessfully Added",
            "New public holiday has been added",
            "text-h5 green--text text-center"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "บันทึกข้อมูล",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      }
      //console.log(this.itemdata);
      await this.loadData();
      this.$hideLoader();
    },

    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthbtnimagefile {
  width: 40%;
}
.widthsizesearch {
  width: 70%;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}
.btnuploadfile {
  border: 2px solid;
}
.heightsize70formadvance {
  height: 80px;
}

.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}

.heightsizesearch {
  height: 45%;
}
</style>
